import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class Tomb extends PhysicalThing {
	static key = "Tomb";
	constructor(xy: XY) {
		super(xy, true);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	static deserialize(data: any): Tomb {
		const t = new Tomb(deserializeXY(data.xy));
		t.visualId = data.visualId;
		return t;
	}
}
